import { observer } from "mobx-react";
import TAGS from "constants/tags";

function Tag({ tag }) {
  const tagRenderData = TAGS.find((t) => t.value === tag.tag);
  if (!tagRenderData) return null;
  return tagRenderData.label;
}

export default observer(Tag);
